/** @format */

const MAX_BYTES = 10 * 1024 * 1024;
const ALLOWED_TYPES = new Set(["application/pdf"]);
const ALLOWED_EXT = /\.pdf$/i;

export function trimFilename(name, maxLen = 32) {
  if (!name || name.length <= maxLen) return name ?? "";
  const dot = name.lastIndexOf(".");
  const ext = dot > 0 ? name.slice(dot) : "";
  const base = dot > 0 ? name.slice(0, dot) : name;
  const budget = maxLen - ext.length - 3;
  if (budget <= 4) return `${name.slice(0, maxLen - 3)}...`;
  const head = Math.ceil(budget / 2);
  const tail = Math.floor(budget / 2);
  return `${base.slice(0, head)}...${base.slice(-tail)}${ext}`;
}

export function validateBolFile(file) {
  if (!file) return { ok: false, error: "No file selected." };
  if (file.size > MAX_BYTES) return { ok: false, error: "PDF must be 10MB or smaller." };
  const isPdf = ALLOWED_TYPES.has(file.type) || ALLOWED_EXT.test(file.name);
  if (!isPdf) return { ok: false, error: "Only PDF files are supported." };
  return { ok: true };
}

export class BolUploadError extends Error {
  constructor(message, { code, notFound = false } = {}) {
    super(message);
    this.name = "BolUploadError";
    this.code = code ?? "BOL_UPLOAD_ERROR";
    this.notFound = notFound;
  }
}
